export default function ResourcesCTA() {
  return (
    <div className="bg-gradient-to-br from-orange-600 via-red-600 to-pink-600 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <h2 className="text-4xl font-bold mb-4">
            Need More Emergency Resources?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-3xl mx-auto">
            Visit our Emergency Resources page for important contacts, safety tips, 
            and real-time emergency information for Roseville residents.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="/emergency"
              className="inline-flex items-center gap-2 bg-white text-orange-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-shield-cross-line text-xl"></i>
              Emergency Resources
            </a>
            <a
              href="https://www.ready.gov/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-all whitespace-nowrap"
            >
              <i className="ri-external-link-line text-xl"></i>
              Ready.gov Resources
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
